// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import {
    getActiveOffices as getActiveOfficesAPI,
    getRegisteredVisits as getRegisteredVisitsAPI,
    getVisitsByCountry as getVisitsByCountryAPI,
    getVisitsByRegion as getVisitsByRegionAPI,
    getInfoSended as getInfoSendedAPI
} from '../../helpers/';
import { dashboardApiResponseError, dashboardApiResponseSuccess } from './actions';
import { DashboardActionTypes } from './constants';
/**
 * Get active offices
 * @param {*} payload - none
 */
function* getActiveOffices() {
    try {
        const response = yield call(getActiveOfficesAPI);
        const activeOffices = response.data.data;
        yield put(dashboardApiResponseSuccess(DashboardActionTypes.GET_ACTIVE_OFFICES, activeOffices));
    } catch (error) {
        yield put(dashboardApiResponseError(DashboardActionTypes.GET_ACTIVE_OFFICES, error));
    }
}

function* getRegisteredVisits() {
    try {
        const response = yield call(getRegisteredVisitsAPI);
        const registeredVisits = response.data.data;
        yield put(dashboardApiResponseSuccess(DashboardActionTypes.GET_REGISTERED_VISITS, registeredVisits));
    } catch (error) {
        yield put(dashboardApiResponseError(DashboardActionTypes.GET_REGISTERED_VISITS, error));
    }
}
function* getVisitsByCountry() {
    try {
        const response = yield call(getVisitsByCountryAPI);
        const visitsByCountry = response.data.data;
        yield put(dashboardApiResponseSuccess(DashboardActionTypes.GET_VISITS_BY_COUNTRY, visitsByCountry));
    } catch (error) {
        yield put(dashboardApiResponseError(DashboardActionTypes.GET_VISITS_BY_COUNTRY, error));
    }
}

function* getVisitsByRegion() {
    try {
        const response = yield call(getVisitsByRegionAPI);
        const visitsByRegion = response.data.data;
        yield put(dashboardApiResponseSuccess(DashboardActionTypes.GET_VISITS_BY_REGION, visitsByRegion));
    } catch (error) {
        yield put(dashboardApiResponseError(DashboardActionTypes.GET_VISITS_BY_REGION, error));
    }
}
function* getInfoSended() {
    try {
        const response = yield call(getInfoSendedAPI);
        const info = response.data.data;
        yield put(dashboardApiResponseSuccess(DashboardActionTypes.GET_INFO_SENDED, info));
    } catch (error) {
        yield put(dashboardApiResponseError(DashboardActionTypes.GET_INFO_SENDED, error));
    }
}


export function* watchGetVisitsByRegion() {
    yield takeEvery(DashboardActionTypes.GET_VISITS_BY_REGION, getVisitsByRegion);
}

export function* watchGetRegisteredVisits() {
    yield takeEvery(DashboardActionTypes.GET_REGISTERED_VISITS, getRegisteredVisits);
}

export function* watchGetActiveOffices() {
    yield takeEvery(DashboardActionTypes.GET_ACTIVE_OFFICES, getActiveOffices);
}

export function* watchGetInfoSended() {
    yield takeEvery(DashboardActionTypes.GET_INFO_SENDED, getInfoSended);
}

export function* watchGetVisitsByCountry() {
    yield takeEvery(DashboardActionTypes.GET_VISITS_BY_COUNTRY, getVisitsByCountry);
}

function* dashboardSaga(): any {
    yield all([
        fork(watchGetActiveOffices),
        fork(watchGetRegisteredVisits),
        fork(watchGetVisitsByCountry),
        fork(watchGetVisitsByRegion),
        fork(watchGetInfoSended),
    ]);
}
export default dashboardSaga;